/**
 * business_licences_controller.js — add and remove rows in the licence list (Stimulus).
 *
 * The Settings form for licence and registration numbers is a plain POST of
 * parallel licence_label / licence_number fields; the schema pairs them on the
 * server. This controller clones the <template> row on "Add", drops a row on its
 * remove button, and keeps each row's two halves required together. Saving is
 * the form's autosave controller (autosave_controller.js), which never posts an
 * invalid form, so a row with one half typed waits instead of failing the
 * server's "both halves or neither" rule.
 *
 * Markup contract inside the root:
 *   [data-business-licences-target="rows"]      the container the rows live in
 *   [data-business-licences-target="template"]  a <template> holding one blank row
 *   [data-licence-row]                          each row, so remove finds its bounds
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['rows', 'template'];

    add() {
        this.rowsTarget.insertAdjacentHTML('beforeend', this.templateTarget.innerHTML);
        const row = this.rowsTarget.lastElementChild;
        const first = row && row.querySelector('input');
        if (first) first.focus();
    }

    remove(event) {
        const row = event.currentTarget.closest('[data-licence-row]');
        if (!row) return;
        row.remove();
        // A removed row changes no field, so announce the edit for autosave.
        this.rowsTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }

    pair(event) {
        const row = event.target.closest('[data-licence-row]');
        if (!row) return;
        const inputs = row.querySelectorAll('input');
        const started = Array.from(inputs).some((input) => input.value.trim());
        inputs.forEach((input) => { input.required = started; });
    }
}
